import PropTypes from 'prop-types';
// @ts-expect-error Could not find a declaration file for module '../p... Remove this comment to see the full error message
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
// @ts-expect-error Could not find a declaration file for module '../p... Remove this comment to see the full error message
import { getTimestamp } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error Could not find a declaration file for module '../p... Remove this comment to see the full error message
import PrimaryMessageHeaderContent from '../../primary-message/components/PrimaryMessageHeaderContent';
// @ts-expect-error Could not find a declaration file for module '../p... Remove this comment to see the full error message
import { getHistoryFormattedTimestamp } from 'conversations-message-history/util/getHistoryFormattedTimestamp';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledPrimaryMessageHeaderContent = styled(PrimaryMessageHeaderContent).withConfig({
  displayName: "AutomatedMessageHeader__StyledPrimaryMessageHeaderContent",
  componentId: "sc-1yxqwnv-0"
})(["padding:8px 8px 0 8px;display:flex;"]);
const StyledSpan = styled.span.withConfig({
  displayName: "AutomatedMessageHeader__StyledSpan",
  componentId: "sc-1yxqwnv-1"
})(["margin-left:auto;"]);
const StyledSmall = styled.small.withConfig({
  displayName: "AutomatedMessageHeader__StyledSmall",
  componentId: "sc-1yxqwnv-2"
})(["display:contents;"]);
const AutomatedMessageHeader = ({
  message
}) => {
  const renderMetadata = () => {
    const timestamp = getTimestamp(message);
    const timestampString = getHistoryFormattedTimestamp(timestamp);
    if (!timestampString) return null;
    return /*#__PURE__*/_jsx(StyledSpan, {
      children: timestampString
    });
  };
  return /*#__PURE__*/_jsx(StyledPrimaryMessageHeaderContent, {
    children: /*#__PURE__*/_jsxs(StyledSmall, {
      children: [/*#__PURE__*/_jsx("strong", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-inbox-message-history.responder.automatic"
        })
      }), renderMetadata()]
    })
  });
};
AutomatedMessageHeader.displayName = 'AutomatedMessageHeader';
AutomatedMessageHeader.propTypes = {
  message: PropTypes.oneOfType([RecordPropType('EmailCaptureResponseMessage'), RecordPropType('EmailCapturePromptMessage'), RecordPropType('OfficeHoursMessage'), RecordPropType('TypicalResponseTimeMessage'), RecordPropType('WorkflowGeneratedUserMessage'), RecordPropType('BatchSmsGeneratedUserMessage')]).isRequired
};
export default AutomatedMessageHeader;